import React from 'react'
import styles from './CategoryItem.module.scss'
import { Category } from '../../../../model/solar-product/category';
import { useNavigate } from 'react-router-dom';

type Props = {
    category: Category | undefined;
}

const CategoryItem: React.FC<Props> = (props: Props) => {
    const { category } = props;
    const navigate = useNavigate();

    const navigateFn = () => {
        navigate(`/store/category/${category?.name}`)
        window.scrollTo(0, 0); // Scroll to the top
    }

    return (
        <div className={styles.container} onClick={navigateFn}>
            <div className={styles.imageContainer}>
                <img src={category?.imageUrl} alt="Category"/>
            </div>
            <div className={styles.name}>
                {category?.name}
            </div>
        </div>
    )
}

export default CategoryItem